import type { OpsAuditAction } from '@nadoutong/contracts';

/**
 * Build a deep link into the audit log viewer with prefilled filters
 * (issue #856). `/governance/audit` initializes both its draft and its
 * applied filter state from the `action` / `targetType` / `targetId`
 * query params, so success toasts on high-risk mutations can land the
 * operator directly on the matching audit rows.
 *
 * `action` is typed as the contracts `OpsAuditAction` union so a typo
 * at a call site is a compile error. The union itself is advisory —
 * the values are hardcoded strings at the backend write sites, and
 * renaming one there silently breaks the corresponding link (epic #853
 * design decision: every referenced literal carries a source-file
 * comment). Current frontend-referenced writers:
 *
 *   - 'payment_order.reconcile'      apps/platform-api/src/routes/internal-ops-payments.ts
 *   - 'gift-card.revoke'             apps/platform-api/src/routes/internal-gift-cards.ts
 *   - 'gift-card.redeem-on-behalf'   apps/platform-api/src/routes/internal-gift-cards.ts
 *   - 'exchange-rate-policy.update'  apps/platform-api/src/routes/internal-pricing.ts
 */
export function auditDeepLink(action: OpsAuditAction, targetId: string): string {
  const params = new URLSearchParams({ action, targetId });
  return `/governance/audit?${params.toString()}`;
}
